<div class="flex flex-col min-h-screen">
  <o-navbar></o-navbar>
  <div class="flex-grow basis-px">
    <router-outlet></router-outlet>
  </div>
  <o-footer></o-footer>
</div>
